module.exports = __webpack_public_path__ + "static/media/contentIntroduction2.bb0a79cc.png";